import { OvTableData } from '../../../components/UI/molecules/OvTable';
import DateUtils from './date-utils';
import { ApiKey, ApiKeyStatus } from '../../model/dto/api-key';
import { TableRowEditWidgetType } from '../../model/ui/table-row-edit-widget.type';
import i18n from 'i18next';

export class ApiKeyDataUtils {
  static mapDataForApiKeyDetailsTable(apiKey: ApiKey): OvTableData {
    return [
      {
        label: 'apiKeys.fields.partnerRoute',
        translateLabel: true,
        value: apiKey.partner_route,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'partner_route',
          placeholder: i18n.t('apiKeys.fields.partnerRoute'),
        },
      },
      {
        label: 'apiKeys.fields.partnerName',
        translateLabel: true,
        value: apiKey.partner_name,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'partner_name',
          placeholder: i18n.t('apiKeys.fields.partnerName'),
        },
      },
      {
        label: 'apiKeys.fields.status',
        translateLabel: true,
        value: i18n.t(`apiKeys.status.${apiKey.status}`),
        editOptions: {
          widgetType: TableRowEditWidgetType.SELECT,
          propertyName: 'status',
          options: [
            {
              value: ApiKeyStatus.ACTIVE,
              label: i18n.t('apiKeys.status.active'),
            },
            {
              value: ApiKeyStatus.INACTIVE,
              label: i18n.t('apiKeys.status.inactive'),
            },
          ],
        },
      },
      {
        label: 'apiKeys.fields.allowedRoutes',
        translateLabel: true,
        value: apiKey.allowed_routes?.join(', ') || '-',
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'allowed_routes',
          placeholder: i18n.t('apiKeys.fields.allowedRoutesPlaceholder'),
        },
      },
      {
        label: 'apiKeys.fields.usageCount',
        translateLabel: true,
        value: apiKey.usage_count,
        editOptions: {
          widgetType: TableRowEditWidgetType.NUMBER,
          propertyName: 'usage_count',
          placeholder: i18n.t('apiKeys.fields.usageCount'),
        },
      },
      {
        label: 'apiKeys.fields.lastUsedAt',
        translateLabel: true,
        value: apiKey.last_used_at
          ? DateUtils.formatDate(
              apiKey.last_used_at as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
      },
      {
        label: 'apiKeys.fields.expiresAt',
        translateLabel: true,
        value: apiKey.expires_at
          ? DateUtils.formatDate(
              apiKey.expires_at as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
        editOptions: {
          widgetType: TableRowEditWidgetType.DATE,
          propertyName: 'expires_at',
        },
      },
      {
        label: 'apiKeys.fields.revocationReason',
        translateLabel: true,
        value: apiKey.revocation_reason || '-',
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'revocation_reason',
          placeholder: i18n.t('apiKeys.fields.revocationReason'),
        },
      },
      {
        label: 'apiKeys.fields.metadata',
        translateLabel: true,
        value: apiKey.metadata ? JSON.stringify(apiKey.metadata, null, 2) : '-',
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'metadata',
          placeholder: i18n.t('apiKeys.fields.metadataPlaceholder'),
        },
      },
      {
        label: 'apiKeys.fields.createdAt',
        translateLabel: true,
        value: apiKey.created_at
          ? DateUtils.formatDate(
              apiKey.created_at as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
      },
      {
        label: 'apiKeys.fields.updatedAt',
        translateLabel: true,
        value: apiKey.updated_at
          ? DateUtils.formatDate(
              apiKey.updated_at as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
      },
    ];
  }
}
